import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0TagRaw } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'
import Upsell from '@factorialco/f0-react/icons/app/Upsell'

import i18n from 'modules/core/lib/i18n'

interface ModalHeaderProps {
  moduleAvatar?: string | null
  moduleName?: string | null
  moduleDescription?: string | null
  onClose: () => void
}

export const ModalHeader = ({
  moduleAvatar,
  moduleName,
  moduleDescription,
  onClose,
}: ModalHeaderProps) => (
  <Box
    flexDirection="column"
    paddingLeft="s16"
    paddingRight="s16"
    paddingTop="s16"
    paddingBottom="s12"
    gap="s12"
    style={{ flexShrink: '0' }}
  >
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexStart">
      <Box
        flexDirection="row"
        alignItems="flexStart"
        gap="s12"
        paddingBottom="s12"
        style={{ minWidth: '0', flex: '1 1 0%' }}
      >
        {moduleAvatar ? (
          <Box
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              backgroundImage: `url(${moduleAvatar})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              flexShrink: '0' as const,
            }}
          />
        ) : null}
        <Box flexDirection="column" gap="s4" style={{ minWidth: '0', flex: '1 1 0%' }}>
          <Box flexDirection="row" alignItems="center" gap="s8" style={{ flexWrap: 'wrap' }}>
            <Text.Header2 weight="semibold">{moduleName ?? ''}</Text.Header2>
            <F0TagRaw icon={Upsell} text={i18n.t('growth.product_modal_extended.upgrade')} />
          </Box>
          {moduleDescription ? (
            <Text.Normal size="200" color="grey700">
              {moduleDescription}
            </Text.Normal>
          ) : null}
        </Box>
      </Box>
      <F0Button
        onClick={onClose}
        variant="outline"
        size="md"
        icon={Cross}
        hideLabel
        round
        label={i18n.t('growth.product_modal_extended.close')}
        style={{ flexShrink: 0 }}
      />
    </Box>
  </Box>
)
